import {
  IWebsiteBuilderElementBase,
  IWebsiteBuilderElementDataBase,
  TWebsiteBuilderElement,
} from "./websiteBuilderElement";
import { websiteBuilderNormalizeArray, websiteBuilderNormalizeValue } from "../../schema/normalization/websiteBuilderNormalizeValue";
import { IWebsiteBuilderNodeDesignStyles } from "../websiteBuilderNode";
import { websiteBuilderGenerateDefaultHideableNodeVisibility } from "../websiteBuilderHideableNode";

export type TWebsiteBuilderListType = "unordered" | "ordered";

function isWebsiteBuilderListType(value: string): value is TWebsiteBuilderListType {
  return value === "unordered" || value === "ordered";
}

export interface IWebsiteBuilderListSettings {
  type: TWebsiteBuilderListType;
  items: string[];
}

export interface IWebsiteBuilderListData extends IWebsiteBuilderElementDataBase {
  type: "list";
  settings: IWebsiteBuilderListSettings;
}

export interface IWebsiteBuilderList extends IWebsiteBuilderElementBase {
  element: IWebsiteBuilderListData;
}

export function isWebsiteBuilderList(node: TWebsiteBuilderElement): node is IWebsiteBuilderList {
  return node?.element?.type === "list";
}

function generateDefaultListSettings(): IWebsiteBuilderListSettings {
  return {
    type: "unordered",
    items: ["Item"], // TODO: Translation
  };
}

export function websiteBuilderGenerateDefaultList(): IWebsiteBuilderList {
  return {
    id: crypto.randomUUID(),
    type: "element",
    element: {
      type: "list",
      layout: {
        desktop: {
          position: { x: 0, y: 0 },
          dimensions: { width: 200, height: 100 },
        },
        tablet: {
          position: { x: 0, y: 0 },
          dimensions: { width: 200, height: 100 },
        },
        mobile: {
          position: { x: 0, y: 0 },
          dimensions: { width: 200, height: 100 },
        },
      },
      visibility: websiteBuilderGenerateDefaultHideableNodeVisibility(),
      zIndex: 0,
      settings: generateDefaultListSettings(),
    },
  };
}

export function websiteBuilderNormalizeListSettings(partialSettings: Partial<IWebsiteBuilderListSettings>): IWebsiteBuilderListSettings {
  const defaultSettings = generateDefaultListSettings();

  if (partialSettings == null) {
    return defaultSettings;
  }

  const { type, items } = partialSettings;

  const normalizedListSettings: IWebsiteBuilderListSettings = {
    type: websiteBuilderNormalizeValue({
      type: "string",
      value: type,
      defaultValue: defaultSettings.type,
      required: true,
      validate: isWebsiteBuilderListType,
    }) as TWebsiteBuilderListType,
    items: websiteBuilderNormalizeArray(items, defaultSettings.items, true, "string") as string[],
  };

  return normalizedListSettings;
}

export function websiteBuilderGenerateListDesignStyles(): IWebsiteBuilderNodeDesignStyles {
  return {
    className: "website-builder-list",
    styleProperties: {},
    styleDeclaration: "",
  };
}
